import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { SharedComponentInterface } from '@core/class/sharedComponent.interface';
import { of, pipe, Subject, Subscription } from 'rxjs';
import { HabitacionService } from '@core/service/habitacion.service';
import { Tarifa } from '@core/model/tarifa.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { map, take } from 'rxjs/operators';

@Component({
  selector: 'app-pagos-calculate',
  templateUrl: './pagos-calculate.component.html',
  styles: []
})
export class PagosCalculateComponent
  implements AfterViewInit, OnInit, OnDestroy, SharedComponentInterface {
  formGroup: FormGroup;
  @Input() habitacionId: any;
  @Input() editarAux: any;
  @Input() subjectShared: Subject<{
    tipo: string;
    total: number;
    precio?: number;
  }>;
  @Output() formReady = new EventEmitter<any>();
  // subscription = this.subjectShared.asObservable();
  private tarifa: Tarifa;
  vuelto = 0;
  private subjectFormChange: Subscription;

  constructor(
    private formBuilder: FormBuilder,
    private habitacionService: HabitacionService
  ) {
    this.formGroup = this.formBuilder.group({
      anticipo: 0,
      total: 0,
      vuelto: 0,
      cantidad: 0,
      detalle: ['']
    });
  }

  ngOnInit(): void {
    // console.log('pagos', this.dias);
    // this.habitacionService.getById(this.habitacionId).subscribe(res => {
    //   console.log('habitacion pagos', res);
    //   this.tarifa = res.tipo.tarifas.find(
    //     (value: { unidad: string }) => value.unidad === 'Día'
    //   );
    // });

    this.formReady.emit({ name: 'pagos', form: this.formGroup });

    this.subjectFormChange = this.formGroup.valueChanges.subscribe(res => {
      // this.vueltoform.pending;
      this.formReady.emit({ name: 'pagos', form: this.formGroup });
      this.calculatePrecio();
      console.log('Change forms', res);
    });

    this.subjectShared.pipe().subscribe(res => {
      // debugger;
      this.formGroup.patchValue({ cantidad: res.total });
      if (res.tipo === 'hora') {
        this.total.patchValue(res.precio);
        this.anticipo.patchValue(res.precio);
      } else {
        // console.log(this.tarifa.precio );
        // this.total.patchValue(0);
        this.total.patchValue(res.precio * this.cantidad);
        this.anticipo.patchValue(res.precio * this.cantidad);
      }
      this.calculatePrecio();
    });
    console.log(
      'editarAux sdf sdf s df sd f sdf s df sdf sdfsdfsdf sdf sd f sdf sdf ',
      this.editarAux
    );
  }

  ngOnDestroy(): void {
    this.subjectShared.unsubscribe();
    this.subjectFormChange.unsubscribe();
  }

  get total() {
    return this.formGroup.get('total');
  }

  get anticipo() {
    return this.formGroup.get('anticipo');
  }

  get cantidad() {
    return this.formGroup.get('cantidad').value;
  }

  get vueltoform() {
    return this.formGroup.get('vuelto');
  }

  calculatePrecio() {
    const res = this.total.value > +this.anticipo.value;
    this.vuelto = res ? 0 : +this.anticipo.value - +this.total.value;
    this.vueltoform.patchValue(this.vuelto, { emitEvent: false });
  }

  ngAfterViewInit(): void {}
}
